module.exports = __webpack_public_path__ + "img/ApartmentOutlined.077259e9.svg";